import { render, staticRenderFns } from "./cardamount.vue?vue&type=template&id=451f2470&"
import script from "./cardamount.vue?vue&type=script&lang=js&"
export * from "./cardamount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports